import { render, staticRenderFns } from "./InstitucionalHeader.vue?vue&type=template&id=442048cc&"
import script from "./InstitucionalHeader.vue?vue&type=script&lang=js&"
export * from "./InstitucionalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports